import React from "react";
import UserTraffic from "../UserTraffic";
import { findParticipant, participantName } from "utils/participants";
import { ConversationHeaderWrapper, ParticipantWrapper, UserTrafficWrapper } from "./styled";

const ConversationHeader = ({ conversation }) => {
  const participations = conversation?.participations;
  const member = findParticipant(participations, "user");
  // The chat opens the member's info on a click here; a removed member has none (it would ask for users/undefined).
  const stopInfoForRemovedMember = (event) => !member && event.stopPropagation();
  return (
    <ConversationHeaderWrapper onClick={stopInfoForRemovedMember}>
      <span>{participantName(participations, "user")} </span>
      <ParticipantWrapper>•</ParticipantWrapper>
      <ParticipantWrapper>{participantName(participations, "coach")}</ParticipantWrapper>

      {/* A removed member has no activity to show, and an empty date would show as active now. */}
      {member && (
        <UserTrafficWrapper>
          <UserTraffic width="10px" height="10px" value={member.last_active_at} />
        </UserTrafficWrapper>
      )}
    </ConversationHeaderWrapper>
  );
};

export default ConversationHeader;
